'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.queue = exports.logger = undefined;

var _level = require('./level');

var logger = exports.logger = {
    name: 'default',
    level: _level.Level.error,
    callback: function callback() {},
    globals: {}
};

var queue = exports.queue = {
    type: 'non-persistent',
    queueSize: 1,
    queueInterval: 60000
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins/lib/defaults.js
// module id = 324
// module chunks = 0